import type { EndpointDefinition } from "../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getEnterpriseInvite: {
        route: "/enterpriseInvites/:id",
        method: "GET"
    }
};
